import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "drawer-employee-detail" }
const _hoisted_2 = { class: "titleClass" }
const _hoisted_3 = { class: "header-info" }
const _hoisted_4 = { class: "avatar-box" }
const _hoisted_5 = { class: "avatar-placeholder" }
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = { class: "name-row" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "gender" }
const _hoisted_10 = { class: "sub-row" }
const _hoisted_11 = { class: "age" }
const _hoisted_12 = { class: "location" }
const _hoisted_13 = { class: "tags-area" }
const _hoisted_14 = {
  key: 0,
  class: "no-data"
}
const _hoisted_15 = { class: "info-list" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "info-row" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-row" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "info-row" }
const _hoisted_23 = { class: "value health-value" }
const _hoisted_24 = { class: "info-list" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "info-row" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "info-row" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "filter-row" }
const _hoisted_32 = {
  key: 0,
  class: "no-data-box"
}
const _hoisted_33 = { class: "info-row" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "info-row" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "info-row" }
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "filter-row" }
const _hoisted_40 = {
  key: 0,
  class: "no-data-box"
}
const _hoisted_41 = { class: "info-row" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "info-row" }
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "info-row" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "info-row" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Male = _resolveComponent("Male")!
  const _component_Female = _resolveComponent("Female")!
  const _component_View = _resolveComponent("View")!
  const _component_Hide = _resolveComponent("Hide")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showDrawer,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDrawer) = $event)),
      "with-header": false,
      "close-on-click-modal": true,
      "append-to-body": true,
      direction: "rtl",
      size: "560px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "" }, "员工详情", -1)),
            _createVNode(_component_el_icon, {
              class: "el-icon--left",
              onClick: _ctx.close,
              size: "32px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close, {
                  size: "32px",
                  color: "#000000"
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "avatar",
                src: _ctx.employeeInfo.userHeadUrl,
                fit: "cover"
              }, {
                error: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getLastChar(_ctx.employeeInfo.workerName)), 1)
                ]),
                _: 1
              }, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.employeeInfo.workerName || '--'), 1),
                _createElementVNode("span", _hoisted_9, "/" + _toDisplayString(_ctx.employeeInfo.sex === '0' ? '男' : '女'), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.employeeInfo.sex === '0')
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Male, { color: "#1989FA" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.employeeInfo.sex === '1')
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Female, { color: "#FF7642" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, "·", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.employeeInfo.age || '--') + "岁", 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "dot" }, "·", -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.employeeInfo.location || '--'), 1)
              ])
            ])
          ])
        ]),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event)),
          type: "card",
          class: "employee-tabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "基本信息",
              name: "basic"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeInfo.workerTags, (tag, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "tag-item"
                    }, _toDisplayString(tag.labelName), 1))
                  }), 128)),
                  (!_ctx.employeeInfo.workerTags || _ctx.employeeInfo.workerTags.length === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 暂无标签 "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "手机号", -1)),
                    _createElementVNode("span", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.maskedFields.phone ? _ctx.formatPhone(_ctx.employeeInfo.phone) : _ctx.employeeInfo.phone ||
                                    '--'), 1),
                      _createVNode(_component_el_icon, {
                        class: "toggle-icon",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.maskedFields.phone = !_ctx.maskedFields.phone))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.maskedFields.phone)
                            ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "身份证号", -1)),
                    _createElementVNode("span", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.maskedFields.idCard ? _ctx.formatIdCard(_ctx.employeeInfo.idCardNo) :
                                    _ctx.employeeInfo.idCardNo || '--'), 1),
                      _createVNode(_component_el_icon, {
                        class: "toggle-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.maskedFields.idCard = !_ctx.maskedFields.idCard))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.maskedFields.idCard)
                            ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      (_ctx.employeeInfo.idCardBack || _ctx.employeeInfo.idCardFront)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "view-icon",
                            onClick: _ctx.handleViewIdCard
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ZoomIn, { color: "#303133" })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "银行卡号", -1)),
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.maskedFields.bankCard ? _ctx.formatBankCardMasked(_ctx.employeeInfo.bankCardNo) :
                                    _ctx.employeeInfo.bankCardNo || '--'), 1),
                      _createVNode(_component_el_icon, {
                        class: "toggle-icon",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.maskedFields.bankCard = !_ctx.maskedFields.bankCard))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.maskedFields.bankCard)
                            ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      (_ctx.employeeInfo.bankCardImg)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "view-icon",
                            onClick: _ctx.handleViewBankCard
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ZoomIn, { color: "#303133" })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "健康证", -1)),
                    _createElementVNode("span", _hoisted_23, [
                      (_ctx.employeeInfo.healthCard)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[14] || (_cache[14] = _createTextVNode(" 已上传 ")),
                            _createVNode(_component_el_icon, {
                              class: "view-icon",
                              onClick: _ctx.handleViewHealthCert
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ZoomIn, { color: "#303133" })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" 未上传 ")
                          ], 64))
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "info-title" }, "求职意向", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "工作地点", -1)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.employeeInfo.workPlace || '未添加'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "工作时段", -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.employeeInfo.workPeriod || '未添加'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "意向行业", -1)),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.employeeInfo.industry || '未添加'), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "工作记录",
              name: "work"
            }, {
              label: _withCtx(() => _cache[20] || (_cache[20] = [
                _createElementVNode("span", null, "工作记录", -1)
              ])),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_date_picker, {
                    size: "",
                    modelValue: _ctx.workMonth,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workMonth) = $event)),
                    type: "month",
                    placeholder: "请选择月份",
                    "value-format": "YYYY-MM",
                    format: "YYYY-MM月",
                    clearable: false,
                    onChange: _ctx.handleWorkMonthChange
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    (_ctx.workRecordList.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 暂无工作记录 "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.workRecordList, (record, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "info-list"
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "项目名称", -1)),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(record.projectName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "用工企业", -1)),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(record.serveCompanyName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "加入时间", -1)),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatDateTime(record.createTime)), 1)
                            ])
                          ]))
                        }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "发薪记录",
              name: "salary"
            }, {
              label: _withCtx(() => _cache[24] || (_cache[24] = [
                _createElementVNode("span", null, "发薪记录", -1)
              ])),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.salaryMonth,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.salaryMonth) = $event)),
                    type: "month",
                    placeholder: "请选择月份",
                    "value-format": "YYYY-MM",
                    format: "YYYY-MM月",
                    clearable: false,
                    onChange: _ctx.handleSalaryMonthChange
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    (_ctx.salaryRecordList.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 暂无发薪记录 "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.salaryRecordList, (record, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "info-list"
                          }, [
                            _createElementVNode("div", _hoisted_41, [
                              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "项目名称", -1)),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(record.projectName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "用工企业", -1)),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(record.serveCompanyName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "发薪金额", -1)),
                              _createElementVNode("span", _hoisted_46, "¥" + _toDisplayString(record.paymentAmount), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "加入时间", -1)),
                              _createElementVNode("span", _hoisted_48, _toDisplayString(record.payTime), 1)
                            ])
                          ]))
                        }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleConfirm
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("确定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.imageViewerVisible)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": _ctx.previewImages,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imageViewerVisible = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ]))
}